import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { CHART_COLORS } from "app/constants/ChartColors";
import { useSubtitleFilters, subtitleFiltersWithCustomColors } from "app/custom-hooks/useSubtitleFilters";
import { translate } from "app/filters/i18nFilter";

import { KeywordsBreakdownTable } from "./KeywordsBreakdownTable";

interface IKeywordsBreakdownWidgetProps {
    isPeriodOverPeriod?: boolean;
    rowLimit?: number;
}

export const KeywordsBreakdownWidget = ({
    isPeriodOverPeriod = false,
    rowLimit,
}: IKeywordsBreakdownWidgetProps) => {
    const subtitleFilters = useSubtitleFilters("date", "country", "webSource");
    const enrichedSubtitleFilters = isPeriodOverPeriod
        ? subtitleFiltersWithCustomColors(
              subtitleFilters,
              CHART_COLORS.periodOverPeriod.Total[0],
              CHART_COLORS.periodOverPeriod.Total[1],
          )
        : subtitleFilters;

    return (
        <WidgetContainer
            withBorder
            title={translate("demand.analysis.search.trends.keywords.breakdown.table.title")}
            tooltip={translate("demand.analysis.search.trends.keywords.breakdown.table.title.tooltip")}
            subtitleFilters={enrichedSubtitleFilters}
            automationId="KeywordsBreakdownTable"
            bodyHeight="auto"
            wrapperHeight="auto"
            bodyMinHeight={0}
        >
            <KeywordsBreakdownTable
                isPeriodOverPeriod={isPeriodOverPeriod}
                rowLimit={rowLimit}
            />
        </WidgetContainer>
    );
};
